import { Component, Vue } from 'vue-property-decorator'

// Enums
import { MissionState } from '@/enums/MissionEnum'

@Component
export default class Mission extends Vue {
  missionStateLegend(state, reportState, report) {
    if ((report.state === 'pending_second' || report.state === 'finished') && reportState === 'pending_first') {
      return this.$t('missions.state.finish')
    }

    if (report.state === 'finished' && reportState === 'pending_second') {
      return this.$t('missions.state.finish')
    }

    return this.$t(`missions.state.${state.toLowerCase()}`)
  }

  missionWasSent(state) {
    return state === MissionState.Send
  }
}
